import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight, ExternalLink } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative py-20 px-4 sm:px-6 lg:px-8 border-t border-border/50">
      <div className="container mx-auto max-w-6xl">
        {/* Final CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="glass-strong rounded-2xl p-8 sm:p-12 text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Pronto para <span className="gradient-text">Evoluir?</span>
          </h2>
          <p className="text-muted-foreground mb-8 max-w-2xl mx-auto text-base sm:text-lg">
            Junte-se a centenas de membros que já estão construindo o futuro da Web3
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg"
              className="bg-primary hover:bg-primary-glow text-primary-foreground font-semibold glow-hover group w-full sm:w-auto"
              onClick={() => window.open('https://ai.eco.br/plans/1956939?bundle_token=98b0c0c2a2973b00d7c39ae8a2114a1a&utm_source=manual', '_blank')}
            >
              Assinar Confraria (R$ 79/ano)
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="glass border-primary/50 text-foreground hover:bg-primary/10 w-full sm:w-auto"
              onClick={() => window.open('https://ai.eco.br/plans/1932767?bundle_token=d0864b27e6b368a32275f3cebaf7e576&utm_source=manual', '_blank')}
            >
              Participar da Oficina
            </Button>
          </div>
        </motion.div>

        {/* Footer Info */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_6b64d89c-5fb6-4989-a00f-bea76b519dd7/artifacts/zdtymixg_icon-mazpcc-NEG-%23ff0062.png" 
              alt="União Confraria" 
              className="h-8 w-8"
            />
            <div>
              <p className="font-semibold text-foreground">União Confraria</p>
              <p>© 2024 Todos os direitos reservados</p>
            </div>
          </div>

          <a 
            href="https://www.confrariaweb3.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-primary transition-colors"
          >
            <span>Visite nosso site</span>
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;